//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Main from "~/components/shop/conf/Main";
import RichTextModule from "@/components/blocks/RichTextModule";
import RecentlyViewedProducts from "@/components/blocks/products/RecentlyViewedProducts";
import RelatedProducts from "@/components/blocks/products/RelatedProducts";
import Reviews from "@/components/blocks/Reviews";

export default {
  name: 'index',
  components: {
    Main,
    RichTextModule,
    RecentlyViewedProducts,
    RelatedProducts,
    Reviews,
  },
  data() {
    return {
      productAnimate: {
        status: false,
        forcedShow: false
      },
      loading: false,
      hasBackUrl: {
        status: false
      },
      isMounted: false
    }
  },
  async asyncData({$axios, route, error, $productServiceData, $api}) {
    const params = {};
    if (route.query.configId) {
      params.sku = route.query.configId
    }
    const product = await $axios.$get(`/products/${route.params.slug.toLowerCase()}`, {params})
      .then(res => {
        // console.log('res', res.data);
        const product = res.data
        if (product.theme.id === $productServiceData.productThemesList.package) {
          product.package = {};
          product.package.types = product.attributes.filter(item => item.attribute_group === $productServiceData.attributeGroupsList.groupColor)
        }

        product.engraving_handwriting_file = null;

        return product
      })
      .catch(err => {
        console.log('error', err);
        error({statusCode: err.response?.status, isApiError: true, apiStatusCode: err.response?.status, apiErrorMessage: err.message});
      })
    const getPageInfo = async () => {
      try {
        const { data } = await $api.pages.getPage('product-details-page?new_page_logic=1');
        return data.data;
      } catch (err) {
        console.log('error', err);
      }
      return null
    }
    const pageInfo = await getPageInfo();
    const pageComponents = {
      'rich-text-module': 'rich-text-module',
      'recently-viewed': 'recently-viewed-products',
      'related-products': 'related-products',
      'reviews': 'reviews',
    };
    const allowedBlockTypes = ['rich-text-module', 'recently-viewed', 'related-products', 'reviews'];
    if(pageInfo?.blocks?.length) {
      pageInfo.blocks.forEach(item => {
        item.code = allowedBlockTypes.includes(item.type.identifier) ? item.type.identifier : item.name;
      });
    }
    return {
      product,
      pageInfo,
      pageComponents
    }
  },
  head() {
    return {
      title: this.product.meta.title,
      meta: [
        {hid: 'description', name: 'description', content: this.product.meta.description},
        {hid: 'keywords', name: 'keywords', content: this.product.meta.keyword},
        {hid: 'robots', name: 'robots', content: 'index, follow'},
        {hid: 'og:title', property: 'og:title', content: this.product.meta.title},
        { hid: 'og:description', property:'og:description', content: this.product.meta.description },
        { hid: 'og:url', property:'og:url', content: this.product.meta.url || `${this.$config.DOMAIN}${this.$route.path}?configId=${this.$route.query.configId}`},
        { hid: 'og:image', property:'og:image', content: this.product.og_image },
        { hid: 'og:type', property:'og:type', content: 'og:product' },
        { hid: 'twitter:title', property:'twitter:title', content: this.product.meta.title },
        { hid: 'twitter:description', property:'twitter:description', content: this.product.meta.description },
        // { hid: 'twitter:image', property:'twitter:image', content: this.$store.state.cdnDomain + this.pageInfo.image },
        // { hid: 'twitter:card', property:'twitter:card', content: 'summary_large_image' }
        { hid: 'product:brand', property:'product:brand', content: 'Silentopus' },
        { hid: 'product:availability', property:'product:availability', content: 'in stock' },
        { hid: 'product:condition', property:'product:condition', content: 'new' },
        { hid: 'product:price:amount', property:'product:price:amount', content: this.product.cost },
        { hid: 'product:price:currency', property:'product:price:currency', content: 'USD' },
        { hid: 'product:retailer_item_id', property:'product:retailer_item_id', content: this.$route.query.configId },
        { hid: 'product:item_group_id', property:'product:item_group_id', content: this.product.vendor_model },
        { hid: 'product:category', property:'product:category', content: "188" },
      ]
    }
  },
  created() {
    /*const params = {};
    if (this.$route.query.configId) {
      params.sku = this.$route.query.configId
    }
    this.$axios.get(`/products/${this.$route.params.slug.toLowerCase()}`, {params})
      .then(res => {
        console.log(res.data);
      })
      .catch(err => {
        error({statusCode: err.response.status});
      })*/

    if (!this.$route.query || !this.$route.query.configId || !this.product.request_config) {
      const query = { configId: this.product.default_config.configuration_id };
      this.$router.replace({ query }).catch(err => {});
    }
  },
  provide() {
    return {
      productAnimate: this.productAnimate,
      hasBackUrl: this.hasBackUrl
    };
  },
  methods: {
    resetProductAnimate() {
      this.productAnimate.status = false;
      setTimeout(() => {
        this.productAnimate.forcedShow = false;
      })
    },
    setRecentlyViewedProducts() {
      if (this.product?.id && this.$route.query?.configId) {
        this.$store.dispatch('setRecentlyViewedProducts', {
          id: this.product.id,
          configuration_id: this.$route.query.configId
        });
      }
    },
    fbEventsInit() {
      let interval = 0;
      interval = setInterval(() => {
        if (typeof fbq === 'function') {
          clearInterval(interval);
          fbq('track', 'ViewContent');
        }
      }, 500)
    }
  },
  watch: {
    "$route.query.configId"(n, o) {
      window.scroll(0, 0);
      this.productAnimate.status = true;
      this.loading = true;
      this.$root.$emit('loading', this.loading)
      if (this.$route.query.configId) {
        const params = {};
        params.sku = this.$route.query.configId;
        this.$axios.get(`/products/${this.$route.params.slug.toLowerCase()}`, {params})
          .then(res => {
            this.product = {
              ...res.data.data,
              // because we don't save engraving_handwriting_file & engraving_images anywhere we have to get them from the product before updating it
              engraving_handwriting_file: this.product.engraving_handwriting_file,
              engraving_configs: this.product.engraving_configs.map(config => {
                if ('engraving_images' in config) {
                  return {
                    ...config,
                    engraving_images: config.engraving_images,
                  }
                }
                return config;
              })
            };
            if (this.product.theme.id === this.constProductThemes().package) {
              this.product.package = {};
              this.product.package.types = this.product.attributes.filter(item => item.attribute_group === 8)
            }
            this.$forceUpdate();
            this.loading = false;
          })
          .catch(err => {
            console.log('error', err);
            this.$nuxt.error({statusCode: err.response?.status, isApiError: true, apiStatusCode: err.response?.status, apiErrorMessage: err.message});
          })
          .then(() => {
            this.resetProductAnimate();
          })
        /*this.$axios.get(`/products/config/${this.$route.query.configId}`)
          .then(res => {
            console.log('res.data', res.data.data);
            this.product = res.data.data
          })
          .catch(err => {
            this.error({statusCode: err.response.status});
          })*/
      } else {
        this.$axios.get(`/products/${this.$route.params.slug.toLowerCase()}`)
          .then(res => {
            console.log('product new', res.data.data);
            this.product = res.data.data;
            setTimeout(() => {
              this.loading = false;
              this.$root.$emit('loading', this.loading)
            }, 500)
          })
          .catch(err => {
            console.log('error', err);
            this.$nuxt.error({statusCode: err.response?.status, isApiError: true, apiStatusCode: err.response?.status, apiErrorMessage: err.message});
          })
          .then(() => {
            this.resetProductAnimate();
          })
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.hasBackUrl.status = Boolean(from.name);
    });
  },
  mounted() {
    this.isMounted = true;
    this.setRecentlyViewedProducts();
    this.fbEventsInit();
  }
}
